import ApiRoutes from "../../../constants/api-routes";
import { hneAdminApi } from "../../../service";

export const deleteImage = async (key) =>
  hneAdminApi.delete(`${ApiRoutes.DELETE_MEDIA_IMAGE}/${key}`);
